import { json } from "@remix-run/cloudflare";
import type { loader as rootLoader } from "./../root";
import {
  type HeadersFunction,
  type LoaderFunctionArgs,
  type MetaFunction,
} from "@remix-run/cloudflare";
import {
  useLoaderData,
  useRouteLoaderData,
} from "@remix-run/react";
import {
  createSbClientBrowser,
  createSbClientSSR,
} from "~/utils/createSbClientSSR";
import { PostService } from "~/database/post.service";
import clsx from "clsx";
import Modal from "~/components/Common/Modal";
import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import TopReccomendPosts from "~/components/Post/TopReccomendPosts";
import TopBreakings from "~/components/Post/TopBreakings";
import TopNewPosts from "~/components/Post/TopNewPosts";
import TopCategoryPosts from "~/components/Post/TopCategoryPosts";
import type { RealtimeChannel } from "@supabase/supabase-js";
import TopWhat from "~/components/Post/TopWhat";

export const useLikeSubscriptions = () => {
  const root =
    useRouteLoaderData<typeof rootLoader>("root");

  const channnelRef =
    useRef<RealtimeChannel | null>(null);
  const init = useCallback(async () => {
    if (
      root?.userData?.id &&
      !channnelRef.current
    ) {
      channnelRef.current =
        await PostService.likeSubscription(
          createSbClientBrowser(),
          root.userData?.id ?? "",
          (like, postId) => {},
        );
    }
  }, [root?.userData?.id]);

  useEffect(() => {
    init();
    return () => {
      channnelRef.current?.unsubscribe();
    };
  }, [init]);
};

export const meta: MetaFunction = () => {
  return [
    { title: "OURPR" },
    {
      name: "description",
      content:
        "OURPR(アワー ・ピーアール)は、より気軽に、より自由に、みんなでより楽しくPR活動を行うためのプラットフォームです。",
    },
  ];
};

// 1️⃣ Choose to enable the emission of logs, or not.

// ~> ℹ info  this important thing happened

export const headers: HeadersFunction = ({
  actionHeaders,
  errorHeaders,
  loaderHeaders,
  parentHeaders,
}) => ({
  "op-cache-status":
    loaderHeaders.get("op-cache-status") ??
    "MISS",
});

export const loader = async ({
  context,
  request,
}: LoaderFunctionArgs) => {
  const headers = new Headers();
  const supabase = createSbClientSSR(
    headers,
    request,
    context,
  );
  try {
    const post = await PostService.getPosts(
      supabase,
      6,
    );
    const recommends =
      await PostService.getTopRecommendedPosts(
        supabase,
        12,
      );
    const categories =
      await PostService.getAllCategory(supabase);
    const topCategoriesPosts =
      await PostService.getTopCategoryData(
        supabase,
      );
    return json(
      {
        posts: post,
        recommends,
        categories,
        topCategoriesPosts,
      },
      {
        headers: headers,
      },
    );
    
  } catch (_e) {
    console.log("_e:", _e);
    const e = _e as Error;
    if (e.message === "ValidationError") {
      throw new Response(null, {
        status: 500,
        statusText: "Server Error",
      });
    }
    throw new Response(null, {
      status: 500,
      statusText: "Server Error",
    });
  }
};

export default function Index() {
  const {
    posts,
    recommends: _recommends,
    categories,
    topCategoriesPosts,
  } = useLoaderData<typeof loader>();
  const [isOoen, setIsOpen] = useState(false);
  const recommends = useMemo(() => {
    return Array.from({ length: 10 + 3 })
      .map((_, i) => {
        return _recommends[
          i % _recommends.length
        ];
      })
      .filter((el) => el);
  }, [_recommends]);
  return (
    <div
      className={clsx(
        "pt-80",
        "pb-0",

        "max-md:pt-90",
      )}
    >
      <TopReccomendPosts
        data={recommends.slice(0, 10)}
      ></TopReccomendPosts>
      <TopWhat></TopWhat>
      <TopBreakings
        data={recommends.slice(10, 13)}
      ></TopBreakings>
      <TopNewPosts data={posts}></TopNewPosts>
      <TopCategoryPosts
        data={topCategoriesPosts}
        category={categories}
      ></TopCategoryPosts>

      {isOoen && (
        <Modal
          title="sd"
          onDismiss={() => {
            setIsOpen(false);
          }}
        >
          <div className="modal">
            <div className="modal-content">
              <span className="close">
                &times;
              </span>
              <p>Some text in the Modal..</p>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
